import Vue from "vue";
import Router, { RouterView } from "vue-router";
import { getToken } from "@/utils/auth";
import Layout from "@/layout";
import { Message } from "element-ui";
import store from "../store";

// 在文件顶部添加
let lastFetchTime = 0;
const CACHE_DURATION = 1 * 60 * 1000; // 5分钟缓存

Vue.use(Router);

const Empty = {
  render(h) {
    return h("router-view");
  },
};

// 公共路由
export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "*",
    component: () => import("@/views/error-page/404"),
    hidden: true,
  },
  {
    path: "/",
    redirect: "/admin/leave", // 添加这一行
    hidden: true, // 可选：隐藏该路由在菜单中显示
  },
  {
    path: "/admin",
    component: Layout,
    redirect: "/admin/leave",
    name: "Admin",
    meta: {
      title: "行政管理",
      icon: "office-building",
      code: "admin.administration",
    },
    children: [
      {
        path: "leave",
        name: "Leave",
        component: () => import("@/views/admin/leave/index"),
        meta: {
          title: "请假审批",
          icon: "document",
          code: "admin.administration.holiday",
        },
      },
      {
        path: "stamp",
        name: "Stamp",
        component: () => import("@/views/admin/stamp/index"),
        meta: {
          title: "用章审批",
          icon: "stamp",
          code: "admin.administration.stamp",
        },
      },
      {
        path: "procurement",
        name: "Procurement",
        component: () => import("@/views/admin/procurement/index"),
        meta: {
          title: "采购审批",
          icon: "s-order",
          code: "admin.administration.purchase",
        },
      },
      {
        path: "consumable",
        name: "Consumable",
        component: () => import("@/views/admin/consumable/index"),
        meta: {
          title: "低值易耗申领",
          icon: "goods",
          code: "admin.administration.consumable",
        },
      },
      {
        path: "material",
        name: "Material",
        component: () => import("@/views/admin/material/index"),
        meta: {
          title: "日常消耗借用",
          icon: "box",
          code: "admin.administration.dailyassetsloan",
        },
      },
    ],
  },
  {
    path: "/maintenance",
    component: Layout,
    redirect: "/maintenance/record",
    name: "Maintenance",
    meta: { title: "维修记录", icon: "tool", code: "admin.repair" },
    children: [
      {
        path: "record",
        name: "MaintenanceRecord",
        component: () => import("@/views/maintenance/record/index"),
        meta: {
          title: "维修列表",
          icon: "list",
          code: "admin.repair.repairlist",
        },
      },
    ],
  },
  {
    path: "/material-management",
    component: Layout,
    redirect: "/material-management/category",
    name: "MaterialManagement",
    meta: { title: "物资管理", icon: "box", code: "admin.assets" },
    children: [
      {
        path: "category",
        name: "MaterialCategory",
        component: () => import("@/views/material-management/category/index"),
        meta: {
          title: "物资类别",
          icon: "s-cooperation",
          code: "admin.assets.category",
        },
      },
      {
        path: "fixed",
        name: "FixedMaterial",
        component: () => import("@/views/material-management/fixed/index"),
        meta: { title: "固定物资", icon: "lock", code: "admin.assets.fixed" },
      },
      {
        path: "daily",
        name: "DailyMaterial",
        component: () => import("@/views/material-management/daily/index"),
        meta: { title: "日常消耗", icon: "s-home", code: "admin.assets.daily" },
      },
      {
        path: "inventory",
        name: "MaterialInventory",
        component: () => import("@/views/material-management/inventory/index"),
        meta: {
          title: "低值易耗",
          icon: "goods",
          code: "admin.assets.consumable",
        },
      },
      {
        path: "food-material",
        name: "FoodMaterial",
        component: () => import("@/views/config/food-material/index"),
        meta: { title: "食材物资", icon: "apple", code: "admin.config.food" },
      },
      {
        path: "log",
        component: Empty,
        name: "MaterialLog",
        redirect: "/material-management/log/outbound",
        meta: { title: "物资日志", icon: "document", code: "admin.assets.log" },
        children: [
          {
            path: "outbound",
            name: "OutboundRecord",
            component: () => import("@/views/material-log/outbound/index"),
            meta: {
              title: "出库记录",
              icon: "upload",
              code: "admin.assets.log",
            },
          },
          {
            path: "inbound",
            name: "InboundRecord",
            component: () => import("@/views/material-log/inbound/index"),
            meta: {
              title: "入库记录",
              icon: "download",
              code: "admin.assets.log",
            },
          },
          {
            path: "scrap",
            name: "ScrapRecord",
            component: () => import("@/views/material-log/scrap/index"),
            meta: {
              title: "物资报废",
              icon: "delete",
              code: "admin.assets.log",
            },
          },
          {
            path: "warning",
            name: "WarningInfo",
            component: () => import("@/views/material-log/warning/index"),
            meta: {
              title: "预警信息",
              icon: "warning",
              code: "admin.assets.log",
            },
          },
          {
            path: "balance",
            name: "BalanceRecord",
            component: () => import("@/views/material-log/balance/index"),
            meta: {
              title: "结余记录",
              icon: "money",
              code: "admin.assets.log",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/config",
    component: Layout,
    redirect: "/config/leave-type",
    name: "ConfigManagement",
    meta: { title: "配置管理", icon: "setting", code: "admin.config" },
    children: [
      {
        path: "leave-type",
        name: "LeaveType",
        component: () => import("@/views/config/leave-type/index"),
        meta: {
          title: "请假类型",
          icon: "menu",
          code: "admin.config.holidaytype",
        },
      },
      {
        path: "qrcode",
        name: "QRCode",
        component: () => import("@/views/config/qrcode/index"),
        meta: {
          title: "二维码管理",
          icon: "qrcode",
          code: "admin.config.qrcode",
        },
      },
      {
        path: "stamp-type",
        name: "StampType",
        component: () => import("@/views/config/stamp-type/index"),
        meta: {
          title: "用章类型",
          icon: "edit",
          code: "admin.config.stamptype",
        },
      },
      {
        path: "supplier",
        name: "Supplier",
        component: () => import("@/views/config/supplier/index"),
        meta: {
          title: "供货商管理",
          icon: "truck",
          code: "admin.config.supplier",
        },
      },
      {
        path: "department",
        name: "Department",
        component: () => import("@/views/config/department/index"),
        meta: {
          title: "部门管理",
          icon: "tree",
          code: "admin.config.department",
        },
      },
      {
        path: "approval",
        name: "Approval",
        component: () => import("@/views/config/approval/index"),
        meta: {
          title: "审批管理",
          icon: "document-checked",
          code: "admin.config.approval",
        },
      },
      {
        path: "atype",
        name: "AType",
        component: () => import("@/views/config/atype/index"),
        meta: {
          title: "审批类型",
          icon: "document-checked",
          code: "admin.config.approveType",
        },
      },
    ],
  },
  {
    path: "/contact",
    component: Layout,
    redirect: "/contact/staff",
    name: "AddressBook",
    meta: {
      title: "信息管理",
      icon: "el-icon-phone",
      code: "admin.contacts",
    },
    children: [
      {
        path: "staff",
        name: "StaffInfo",
        component: () => import("@/views/contact/staff/index"),
        meta: {
          title: "职工信息",
          icon: "el-icon-user",
          code: "admin.contacts.employee",
        },
      },
    ],
  },
  {
    path: "/permission",
    component: Layout,
    redirect: "/permission/role-permission",
    name: "Permission",
    meta: { title: "权限管理", icon: "key", code: "admin.permission" },
    children: [
      {
        path: "role-permission",
        name: "RolePermission",
        component: () => import("@/views/permission/role-permission/index"),
        meta: {
          title: "角色权限",
          icon: "lock",
          code: "admin.permission.role",
        },
      },
    ],
  },
  {
    path: "/system",
    component: Layout,
    redirect: "/system/user",
    name: "System",
    meta: { title: "设置", icon: "setting", code: "" }, // 公开页面 code 为空
    children: [
      {
        path: "user",
        name: "User",
        component: () => import("@/views/system/user/index"),
        meta: { title: "个人信息", icon: "user", code: "" }, // 公开页面 code 为空
      },
    ],
  },
];

const createRouter = () =>
  new Router({
    mode: "hash",
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// 重置路由

// router.beforeEach(async (to, from, next) => {
//   const token = getToken();

//   // 白名单路径直接放行
//   if (to.path === "/login" || to.path === "/404") {
//     return next();
//   }

//   // 无token统一跳转登录
//   if (!token) {
//     return next("/login");
//   }

//   // 获取用户权限
//   const permissionStr = localStorage.getItem("user_permissions");
//   const userPermissions = permissionStr ? JSON.parse(permissionStr) : [];
//   const permissionCodeArr = [...new Set(userPermissions.map((p) => p.code))];

//   // 获取公共数据（带缓存）
//   // if (Date.now() - lastFetchTime > CACHE_DURATION) {
//   try {
//     await Promise.all([
//       store.dispatch("getCodeList"),
//       store.dispatch("getDepartmentPage"),
//       store.dispatch("getSupplierList"),
//     ]);
//     // lastFetchTime = Date.now();
//   } catch (error) {
//     console.error("获取公共数据失败:", error);
//     // 即使获取失败也不应该阻止用户访问页面
//   }
//   // }
//   // 权限检查
//   const requiredCode = to.meta.code || "";

//   // 如果该路由不需要权限码，直接放行
//   if (!requiredCode) {
//     return next();
//   }

//   // 如果有权限码且当前用户有该权限，放行
//   if (permissionCodeArr.includes(requiredCode)) {
//     return next();
//   }

//   // 没有权限
//   Message.error("权限不足，无法访问该页面");
//   next(false);
// });
// router 权限拦截（兼容无 optional chaining 的环境）
router.beforeEach(async (to, from, next) => {
  const token = getToken();

  // 白名单路径直接放行
  if (["/login", "/404"].indexOf(to.path) !== -1) {
    return next();
  }

  // 无 token 跳登录
  if (!token) {
    return next("/login");
  }

  // 获取用户权限数组
  var permissionStr = localStorage.getItem("user_permissions");
  var userPermissions = permissionStr ? JSON.parse(permissionStr) : [];
  var permissionCodeArr = Array.from(new Set(userPermissions.map(function (p) { return p.code; })));

  // 获取公共数据（忽略失败，不阻塞路由）
  try {
    await Promise.all([
      store.dispatch("getCodeList"),
      store.dispatch("getDepartmentPage"),
      store.dispatch("getSupplierList")
    ]);
  } catch (err) {
    console.error("获取公共数据失败:", err);
  }

  var requiredCode = (to.meta && to.meta.code) ? to.meta.code : "";

  // 路由不需要权限直接放行
  if (!requiredCode) {
    return next();
  }

  // 如果有权限直接放行
  if (permissionCodeArr.indexOf(requiredCode) !== -1) {
    return next();
  }

  // 没有权限：尝试找到第一个用户有权限的路由并跳转过去
  Message.warning("权限不足，自动跳转到可访问页面...");

  // 获取路由列表（兼容不同版本 VueRouter）
  var allRoutes = [];
  if (typeof router.getRoutes === "function") {
    try {
      allRoutes = router.getRoutes(); // vue-router 3.5+/4
    } catch (e) {
      allRoutes = router.options && router.options.routes ? router.options.routes : [];
    }
  } else {
    allRoutes = router.options && router.options.routes ? router.options.routes : [];
  }

  // 递归查找第一个符合权限的路由对象（返回其 path）
  function findFirstAccessible(routes) {
    if (!routes || !routes.length) return null;
    for (var i = 0; i < routes.length; i++) {
      var r = routes[i];

      // 跳过登录、404 等不需要的路由
      var p = r.path;
      if (p === "/login" || p === "/404") {
        // continue
      } else {
        // meta 存在且有 code
        var meta = r.meta || {};
        if (meta.code && permissionCodeArr.indexOf(meta.code) !== -1) {
          // 如果是命名路由可能没有 path，优先返回 path 或 name
          return r.path || (r.name ? { name: r.name } : null);
        }
      }

      // 如果有 children，递归查找
      if (r.children && r.children.length) {
        var childResult = findFirstAccessible(r.children);
        if (childResult) return childResult;
      }
    }
    return null;
  }

  var accessible = findFirstAccessible(allRoutes);

  if (accessible) {
    // 如果返回的是对象（命名路由），用 next(accessible)，否则 next({ path })
    return next(accessible);
  } else {
    // 没有可访问的路由则跳 404 或默认首页
    return next("/404");
  }
});

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;
